export const s3ImageLink = 'https://website-resource.ahaglobal.io/ads-platform/';

export const supportEmail = 'support@ahacreator.com';

export const ahaCreatorLink = 'https://www.ahacreator.com';